import { RootState } from "../../../store/root.reducer";
import { getNotifications } from "../../../store/root.selectors";

export const getNotificationList = (state: RootState) =>
  getNotifications(state).list;
